export const PDF_IS_READY = 'The PDF is ready to download';
export const PDF_IS_GENERATING = 'Generating PDF';
export const PDF_IS_UPLOADING = 'Uploading data';
export const PDF_IS_DOWNLOADING = 'Downloading';
